const wsUrl = process.env?.REACT_APP_WEBSOCKET_URL || "wss://" + window.location.host;
const WsConnector = function () {
    return {
        ws: null,
        url: "",
        opened: () => {
        },
        closered: function () {
        },
        error: (e) => {
            console.log("[WsConnector] Error ")
            console.log(e)
        },
        message: (e) => {
            let data = JSON.parse(e.data);
            console.log("[WsConnector] message", data);
        },
        close: function (){
            if (this.ws && this.ws.readyState <= 1){
                this.ws.close();
                this.ws = null
            }
        },
        setUrl: function(url){
            this.url = wsUrl + url;
            this.url += "?token=" + localStorage.getItem("token")
        },
        connect: function () {
            if (this.ws && this.ws.readyState <= 1) {
                this.ws.close();
                this.ws = null;
            }
            if (!this.url) {
                console.error("Not url to WS connect");
                return;
            }
            this.ws = new WebSocket(this.url);
            this.ws.onopen = this.opened;
            this.ws.onclose = this.closered;
            this.ws.onerror = this.error;
            this.ws.onmessage = this.message;
        }
    }
}
export default WsConnector